// extracted by mini-css-extract-plugin
export default {"statusActive":"MastersList_statusActive__B33+S","statusInactive":"MastersList_statusInactive__KzikW","mastersListWrapper":"MastersList_mastersListWrapper__PJxRK"};